import React, { Component } from 'react';
import styled from '@emotion/styled';
import colors from 'styles/colors';
/*import dimensions from 'styles/dimensions';*/
import CleanInput from 'components/_ui/CleanInput';
import Content from 'components/_ui/Content';

const ReadMoreContainer = styled.div``;

const ReadMoreWrapper = styled.div`
  position: relative;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-in-out;
  
  .is-open & {
    max-height: 200rem;
    transition: max-height 0.5s ease-in-out;
  }
`;

const ReadMoreToggle = styled(CleanInput)`
  color: ${colors.red500};
  font-size: 1.8rem;
  font-weight: 600;
  margin-top: 1.6rem;
  cursor: pointer;
`;

class ReadMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggleContent = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  render() {
    const self = this;

    return (
      <ReadMoreContainer className={`${self.state.isOpen ? 'is-open' : ''}`}>
        <ReadMoreWrapper>
          <Content content={self.props.content}/>
        </ReadMoreWrapper>

        <ReadMoreToggle
          type='button'
          value={self.state.isOpen ? 'Read Less' : 'Read More'}
          onClick={() => {self.toggleContent()}}
        >
        </ReadMoreToggle>
      </ReadMoreContainer>
    );
  }
}

export default ReadMore;
